import React from 'react';

const Privacy = () => {
    return (
        <div className="min-h-screen flex flex-col bg-[#0E101D]">
            <div className="flex-grow container mx-auto px-4 py-20 mt-10 max-w-4xl">
                <h1 className="text-4xl md:text-5xl font-vt323 text-[#ff0055] mb-8 text-center uppercase tracking-widest">Privacy Policy</h1>

                <div className="space-y-8 font-vt323 text-xl tracking-wide text-gray-300">
                    <section className="bg-[#161823] p-8 border-l-4 border-[#ff0055]">
                        <h2 className="text-2xl text-white mb-4 uppercase">1. Introduction</h2>
                        <p>Your privacy is important to us. This policy explains how Blue Pixelated handles your data. We believe in transparency and minimizing data collection.</p>
                    </section>

                    <section className="bg-[#161823] p-8 border-l-4 border-[#00d0ff]">
                        <h2 className="text-2xl text-white mb-4 uppercase">2. Permissions</h2>
                        <ul className="list-disc list-inside space-y-2 ml-4">
                            <li><span className="text-[#00d0ff]">Camera Access:</span> We require access to your device's camera to function (e.g., taking photos to apply filters).</li>
                            <li><span className="text-[#00d0ff]">Photo Library Access:</span> We require access to your photo library to save your creations.</li>
                        </ul>
                    </section>

                    <section className="bg-[#161823] p-8 border-l-4 border-[#ffdd00]">
                        <h2 className="text-2xl text-white mb-4 uppercase">3. Data Collection</h2>
                        <p className="mb-2">We respect your privacy by design:</p>
                        <ul className="list-disc list-inside space-y-2 ml-4">
                            <li>All image processing happens <span className="text-[#ffdd00]">locally on your device</span>.</li>
                            <li>We do not upload your photos to any external servers.</li>
                            <li>We do not collect personal identifiable information (PII).</li>
                        </ul>
                    </section>

                    <section className="bg-[#161823] p-8 border-l-4 border-[#ff0055]">
                        <h2 className="text-2xl text-white mb-4 uppercase">4. Contact</h2>
                        <p>If you have questions about this policy, please contact us at <a href="mailto:support@pixelatedcamera.app" className="text-[#ff0055] hover:underline">support@pixelatedcamera.app</a>.</p>
                    </section>

                    <p className="text-center text-gray-500 mt-12 text-lg">Last Updated: December 2024</p>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
